export var version = {
  lib: '2.7968.10',
  product: '2.7968.10',
  supportedApiVersion: 2
};



// WEBPACK FOOTER //
// ./src/misc/Version.ts